import * as React from "react";
import { TimetableComponent, TimetableData } from "./Timetable";

export interface RowStatus {
    morning: boolean;
    afternoon: boolean;
    night: boolean;
}
export interface ColStatus {
    Sun: boolean;
    Mon: boolean;
    Tue: boolean;
    Wed: boolean;
    Thu: boolean;
    Fri: boolean;
    Sat: boolean;
}

export interface RowsAndColsStatus {
    rowsStatus: RowStatus;
    colsStatus: ColStatus;
    onChange: () => void;
}

export interface FakeComponentProps {
    value: TimetableData;
    events: any;
    field: any | null;
    updateCheckTimetableFlag: boolean;
    isCpmOrVcpmModel: boolean;
    onChangeUpdateCheckTimetableFlag: (status: boolean) => void;
    onOpenTimetableWarning: () => void;
}

export class FakeComponent extends React.Component<FakeComponentProps, any> {
    constructor(props: FakeComponentProps) {
        super(props);
        this.state = {
            value: this.props.value || {
                Sun: { morning: true, afternoon: true, night: true },
                Mon: { morning: true, afternoon: true, night: true },
                Tue: { morning: true, afternoon: true, night: true },
                Wed: { morning: true, afternoon: true, night: true },
                Thu: { morning: true, afternoon: true, night: true },
                Fri: { morning: true, afternoon: true, night: true },
                Sat: { morning: true, afternoon: true, night: true }
            }
        };
        this.checkFullRowsAndCols = this.checkFullRowsAndCols.bind(this);
        this.setTimetableToMediaPlanFormState = this.setTimetableToMediaPlanFormState.bind(this);
        this.checkForEmptyTable = this.checkForEmptyTable.bind(this);
    }

    setTimetableToMediaPlanFormState() {
        this.props.events.fields.timetable.onChange(this.state.value);
    }

    componentDidUpdate(prevProps: FakeComponentProps) {
        const { updateCheckTimetableFlag, onChangeUpdateCheckTimetableFlag, value } = this.props;

        if (updateCheckTimetableFlag) {
            this.setState({
                ...this.state,
                value: value
            });
            onChangeUpdateCheckTimetableFlag(false);
            return;
        }

        if (prevProps.updateCheckTimetableFlag === true && updateCheckTimetableFlag === false) {
            this.checkFullRowsAndCols();
        }

        return;
    }

    componentDidMount() {
        this.checkFullRowsAndCols();
        // this.setTimetableToMediaPlanFormState();
    }

    onChange(weekDay: string, dayTime: string) {
        const weekDays: TimetableData = this.state.value;
        const newWeek: TimetableData = weekDays;

        for (let day in weekDays) {
            if (weekDay === day) {
                newWeek[day][dayTime] = !weekDays[day][dayTime];
            }
        }

        this.setState({
            ...this.state,
            value: newWeek
        });

        this.checkFullRowsAndCols();
        this.setTimetableToMediaPlanFormState();
    }

    onRowChange(dayTime: string) {
        const weekDays: TimetableData = this.state.value;
        const newWeek: TimetableData = weekDays;

        let isAllTimeIWeekTrue: boolean = true;

        for (let day in weekDays) {
            if (isAllTimeIWeekTrue) {
                if (weekDays[day][dayTime] === false) {
                    isAllTimeIWeekTrue = false;
                }
            }
        }

        if (isAllTimeIWeekTrue) {
            for (let day in weekDays) {
                newWeek[day][dayTime] = false;
            }
        } else {
            for (let day in weekDays) {
                newWeek[day][dayTime] = true;
            }
        }

        this.setState({
            ...this.state,
            value: newWeek
        });

        this.checkFullRowsAndCols();
        this.setTimetableToMediaPlanFormState();
    }

    onColChange(weekDay: string) {
        const weekDays: TimetableData = this.state.value;
        const newWeek: TimetableData = weekDays;

        if (
            weekDays[weekDay]["morning"] === true &&
            weekDays[weekDay]["afternoon"] === true &&
            weekDays[weekDay]["night"] === true
        ) {
            newWeek[weekDay]["morning"] = false;
            newWeek[weekDay]["afternoon"] = false;
            newWeek[weekDay]["night"] = false;
        } else {
            newWeek[weekDay]["morning"] = true;
            newWeek[weekDay]["afternoon"] = true;
            newWeek[weekDay]["night"] = true;
        }

        this.setState({
            ...this.state,
            value: newWeek
        });

        this.checkFullRowsAndCols();
        this.setTimetableToMediaPlanFormState();
    }

    checkFullRowsAndCols() {
        const weekDays: TimetableData = this.state.value;
        let rowsStatus: RowStatus = {
            morning: undefined,
            afternoon: undefined,
            night: undefined
        };

        let morningStatus: boolean = true;
        let afternoonStatus: boolean = true;
        let nightStatus: boolean = true;

        for (let day in weekDays) {
            if (morningStatus) {
                if (weekDays[day]["morning"] === false) morningStatus = false;
            }
        }

        for (let day in weekDays) {
            if (afternoonStatus) {
                if (weekDays[day]["afternoon"] === false) afternoonStatus = false;
            }
        }

        for (let day in weekDays) {
            if (nightStatus) {
                if (weekDays[day]["night"] === false) nightStatus = false;
            }
        }

        rowsStatus = {
            morning: morningStatus,
            afternoon: afternoonStatus,
            night: nightStatus
        };

        let colsStatus: ColStatus = {
            Sun: undefined,
            Mon: undefined,
            Tue: undefined,
            Wed: undefined,
            Thu: undefined,
            Fri: undefined,
            Sat: undefined
        };

        for (let day in weekDays) {
            if (
                weekDays[day]["morning"] === true &&
                weekDays[day]["afternoon"] === true &&
                weekDays[day]["night"] === true
            ) {
                colsStatus[day] = true;
            } else {
                colsStatus[day] = false;
            }
        }

        if (this.props.isCpmOrVcpmModel) {
            const isWeekEmpty = this.checkForEmptyTable();

            if (isWeekEmpty) {
                this.props.onOpenTimetableWarning();
            }
        }

        return this.setState({
            ...this.state,
            RowsAndColsStatus: {
                rowsStatus: rowsStatus,
                colsStatus: colsStatus
            }
        });
    }

    onChangeAll() {
        const weekDays: TimetableData = this.state.value;
        const newWeek: TimetableData = weekDays;

        let isAllTimeIWeekTrue: boolean = true;

        const dayTime = ["morning", "afternoon", "night"];

        for (let day in weekDays) {
            for (let time in dayTime) {
                if (isAllTimeIWeekTrue) {
                    const currentTime = dayTime[time];
                    if (weekDays[day][currentTime] === false) {
                        isAllTimeIWeekTrue = false;
                    }
                }
            }
        }

        if (isAllTimeIWeekTrue) {
            for (let day in weekDays) {
                for (let time in dayTime) {
                    const currentTime = dayTime[time];
                    newWeek[day][currentTime] = false;
                }
            }
        } else {
            for (let day in weekDays) {
                for (let time in dayTime) {
                    const currentTime = dayTime[time];
                    newWeek[day][currentTime] = true;
                }
            }
        }

        this.setState({
            ...this.state,
            value: newWeek
        });

        this.checkFullRowsAndCols();
        this.setTimetableToMediaPlanFormState();
    }

    checkForEmptyTable(): boolean {
        let isWeekEmpty: boolean = true;
        const timetable = this.state.value;

        for (let day in timetable) {
            for (let time in timetable[day]) {
                if (timetable[day][time] === true) {
                    isWeekEmpty = false;
                }
            }
        }

        return isWeekEmpty;
    }

    render() {
        return (
            <TimetableComponent
                value={this.state.value}
                RowsAndColsStatus={this.state.RowsAndColsStatus}
                onChange={(weekDay: string, dayTime: string) => this.onChange(weekDay, dayTime)}
                onRowChange={(dayTime: string) => this.onRowChange(dayTime)}
                onColChange={(weekDay: string) => this.onColChange(weekDay)}
                onChangeAll={() => this.onChangeAll()}
                field={this.props.field}
            />
        );
    }
}
